<template>
  <div class="grid-x grid-padding-x grid-padding-y pega-form">
    <template v-if="$slots.label">
      <slot name="label" />
    </template>
    <div
      v-else-if="label"
      class="medium-3 cell pega-form-label"
    >
      {{ label }}
    </div>
    <div class="auto cell">
      <template v-if="$slots.header">
        <slot name="header" />
      </template>
      <component
        :is="tag"
        :value="value"
        :type="type"
        :class="className"
        :placeholder="placeholder"
        v-bind="$attrs"
        class="pega-form-item"
        data-test="item"
        @input="update"
        @keypress="keypress"
      >
        <template v-if="$slots.body">
          <slot name="body" />
        </template>
        <template v-else>
          {{ value }}
        </template>
      </component>
      <template v-if="$slots.error">
        <slot name="error" />
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'input'
    },
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: ''
    },
    className: {
      type: [String, Array, Object],
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  methods: {
    update (e) {
      this.$emit('input', e.target.value)
      this.$emit('change', e.target.value)
    },
    keypress (e) {
      this.$emit('keypress', e)
    }
  }
}
</script>
